<template>
  <BModal
    id="modal-daily-limit-error"
    ref="modal-daily-limit-error"
    hide-footer
    hide-header
    hide-header-close
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="text-center">
      <img
        src="https://storage.googleapis.com/komerce/assets/svg/Icon-Warning.svg"
        alt="Warning"
        class="mx-auto my-2"
        width="64"
      >
      <div class="flex flex-col gap-3 mb-2">
        <h3 class="font-bold text-2xl text-[#333333]">
          {{ errorTitle }}
        </h3>
        <p class="text-[#626262]">
          {{ errorMessage }}
        </p>
      </div>
      <BButton
        variant="primary"
        block
        class="mb-1"
        @click="$bvModal.hide('modal-daily-limit-error')"
      >
        Mengerti
      </BButton>
    </div>
  </BModal>
</template>

<script>
export default {
  props: {
    errorTitle: {
      type: String,
      default: 'Limit harianmu saat ini belum dapat ditingkatkan',
    },
    errorMessage: {
      type: String,
      default: 'Yuk tingkatkan spending atau hubungi CS',
    },
  },
}
</script>
